import styled from "styled-components";

export const Container = styled.div`
	width: 100%;
	margin-top: 1rem;
`;

export const ContainerCard = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	row-gap: 0.2rem;

	header {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	strong {
		display: block;
		font-size: 0.9rem;
		font-weight: bold;
		line-height: 0.5rem;
	}
`;

export const Content = styled.div`
	display: grid;
	grid-template-columns: 220px 1fr 50px 50px;
	grid-auto-flow: column;
	grid-gap: 1rem;

	background: #fff;
	width: 100%;
	min-width: 960px;
	cursor: pointer;

	padding: 0.4rem 1rem;
	border-radius: 4px;
	align-items: center;

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		grid-template-columns: 115px 115px 25px 25px;
		gap: 2px;
		padding: 0.4rem 0.25rem;
		min-width: 295px;
	}

	p {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: break-spaces;
		margin: 0;
	}

	&:hover {
		background-color: #f1f1f1;
	}
	> div {
		justify-content: center;
	}
`;

export const boxContainer = styled.div`
	background: ${({ theme }) => theme.grayLight} !important;
	padding: 1em;
	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		padding: 0.5em;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		padding: 0.025em;
	}
`;

export const ContentContainer = styled.div`
	width: 100%;
	overflow: auto;
	border-radius: 4px;
	box-shadow: rgba(0, 0, 0, 0.15) 0 1px 2.6px;
	margin-bottom: 10px;
`;

export const AreaIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	.MuiSvgIcon-root {
		color: ${({ theme }) => theme.pantone2726C};
	}
`;

export const ContentCollapse = styled.div`
	padding: 0.6rem 1rem;
	background: ${({ theme }) => theme.white};
`;

export const EndMessage = styled.div`
	color: ${({ theme }) => theme.pantoneBlack};
	font-size: 14px;
	font-weight: bold;
	padding: 10px 0px;
`;

export const TooltipText = styled.p`
	margin: 0;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	width: 100%;
	max-width: 300px;
`;

export const AreaButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: right;
	margin-top: 1em;
	margin-right: 1em;
`;
